import React, { useEffect, useState } from "react";

import Modal from "react-bootstrap/Modal";
import StepWizard from "react-step-wizard";
import { toast } from "react-toastify";
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";
import axios from "@app/lib/axios";
import Table from "./Component.js";
import * as Constant from "@app/Constant.js";
import * as util from "@app/lib/utility";

const ContractInfo = ({ tableId, bizApp, serviceAppList, appAuthTypeList, list, director, isRecontractSeason, seasonInfo, changeList }) => {
    const [bizAppMap, setBizAppMap] = useState(false);
    useEffect(() => {
        return () => {};
    }, [bizApp, serviceAppList, list, director]);
    useEffect(() => {
        initBizApp(bizApp, list);
        return () => {};
    }, [bizApp, serviceAppList, list]);
    const initBizApp = (bizApp) => {
        if (bizApp && list) {
            const newBizAppMap = Table.func.getBizAppMap(bizApp, null, true);
            updateContractTotal(newBizAppMap);
        }
    };
    const updateContractTotal = (bizAppMap) => {
        if (bizAppMap) {
            let newBizAppMap = { ...bizAppMap };
            Object.keys(bizAppMap).forEach((a) => {
                newBizAppMap[a].count = 0;
                newBizAppMap[a].quantity = 0;
            });
            
            list.forEach((c) => {
                if (c.is555) return;
                Object.keys(bizAppMap).forEach((a) => {
                    if (newBizAppMap[a].info && newBizAppMap[a].info.contractUseTas && c.app_auth[a] && c.app_auth[a].approval === "AP") {
                        newBizAppMap[a].count++;
                        newBizAppMap[a].quantity += Number(newBizAppMap[a].hasCellQuantity ? c[newBizAppMap[a].info.quantity.field[0]] : c.quantity);
                    }
                });
            });
            setBizAppMap(newBizAppMap);
        }
    };

    if(!bizApp || !serviceAppList || !bizAppMap) {
        return <></>;
    }

    let quantityCnt = 0;
    if (list) {
        list.forEach((c) => {
            // 555계정 계약 개수 제외
            if (c.is555) return;
            let quantityAdded = false;
            serviceAppList.forEach((a) => {
                if(a.contractUseTas && c.app_auth[a.key] && c.app_auth[a.key].approval === "AP") {
                    if(!quantityAdded && !bizAppMap[a.key].hasCellQuantity) {
                        quantityCnt += c[bizAppMap[a.key].info.quantity.field[0]];
                        quantityAdded = true;
                    }
                }
            });
        });
    }

    const colSpanApp = serviceAppList.reduce((acc, a) => bizAppMap[a.key] ? (acc + (bizAppMap[a.key].fold ? 1 : 2 + bizAppMap[a.key].colAdd)) : acc, 0);

    return (
        <div className="div-table-contract div-table-contract-view">
            <table id={tableId || "contractInfoTable"} className="table table-bordered table-contract table-contract-view">
                <Table.Header.Default bizApp={bizAppMap} serviceAppList={serviceAppList} isView={true} />
                <tbody>
                    {(!list || list.length === 0) && (
                        <tr className={"table-contract-tr"}>
                            <td style={{height: "100px"}} colSpan={5 + colSpanApp}>
                                계약이 존재하지 않습니다.
                            </td>
                        </tr>
                    )}
                    {director &&
                        director.map((c, idx) => {
                            const appAuth = c.app_auth;
                            return (
                                <tr className={"table-contract-tr"} key={`table-contract-info-tr-${idx}`}>
                                    <td className="text-center table-contract-td">
                                        <Table.UserIdViewCell contract={c} serviceAppList={serviceAppList} />
                                    </td>
                                    <td style={{ textAlign: "left" }}>{c.name}</td>
                                    <td className="text-center" style={{backgroundColor: "#f4f6f9"}}></td>
                                    <td className="text-center" style={{backgroundColor: "#f4f6f9"}}></td>
                                    <td className="text-center" style={{backgroundColor: "#f4f6f9"}}></td>

                                    {serviceAppList ? (
                                        serviceAppList.map((a) => {
                                            if(a.contractUseTas && bizAppMap[a.key]) {
                                                return (
                                                    <Table.ViewCell
                                                        key={`table-view-d-${idx}-${a.key}`}
                                                        bizApp={bizAppMap[a.key]}
                                                        age={c[a.age.field]}
                                                        quantity={c[a.quantity.field[0]]}
                                                        auth={appAuth[a.key]}
                                                        is555={true}
                                                        role="D"
                                                        needRecontract={false}
                                                    />
                                                );
                                            }
                                        })
                                    ) : <></>}
                                </tr>
                            );
                        })}
                    {director && director.length > 0 && (
                        <tr className={"table-contract-tr"}>
                            <td
                                className="p-0 pb-1"
                                style={{ backgroundColor: "#eee" }}
                                colSpan={4 + colSpanApp}
                            ></td>
                        </tr>
                    )}
                    {list &&
                        list.map((c, idx) => {
                            const appAuth = c.app_auth;
                            const hasApproval = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval == "WT" || c.app_auth[a.key].approval == "AP") == true), false);
                            const unionName = Table.func.getUnionName(serviceAppList, appAuthTypeList, appAuth);

                            return (
                                <tr className={"table-contract-tr"} key={`table-contract-info-tr-${idx}`}>
                                    <td className="text-center table-contract-td">
                                        <Table.UserIdViewCell
                                            key={`table-view-user-${idx}`}
                                            contract={c}
                                            serviceAppList={serviceAppList}
                                            onClassUpdate={(e) => {
                                                if (e.name) {
                                                    const newList = [...list];
                                                    newList[idx].class_name = e.name;
                                                    changeList(newList);
                                                }
                                            }}
                                        />
                                    </td>
                                    <td style={{ textAlign: "left", color: `${c.is_new && !c.is555 ? " red" : "#71748d"}` }}>{c.class_name}</td>
                                    <td className="text-left" style={{ color: `${c.is_new && !c.is555 ? " red" : "#71748d"}`, backgroundColor: "#f4f6f9" }}>{c.is555 ? '' : c.quantity}</td>
                                    <td className="text-center" style={{ color: `${c.is_new && !c.is555 ? " red" : "#71748d"}`, backgroundColor: "#f4f6f9" }}>{c.is555 ? '' : (c.device == 'tablet' ? '태블릿' : '전자칠판')}</td>
                                    <td className={`text-center ${unionName ? 'text-union' : 'text-gray'}`} style={{backgroundColor: "#f4f6f9"}}>{unionName || '결합 없음'}</td>

                                    {serviceAppList ? (
                                        serviceAppList.map((a) => {
                                            if(a.contractUseTas && bizAppMap[a.key]) {
                                                return (
                                                    <Table.ViewCell
                                                        key={`table-view-${idx}-${a.key}`}
                                                        bizApp={bizAppMap[a.key]}
                                                        age={c[a.age.field]}
                                                        quantity={c[a.quantity.field[0]]}
                                                        auth={appAuth[a.key]}
                                                        is555={c.is555}                                                        
                                                        needRecontract={isRecontractSeason && appAuth[a.key] && appAuth[a.key].need_recontract > 0}
                                                    />
                                                );
                                            }
                                        })
                                    ) : <></>}
                                </tr>
                            );
                        })}
                </tbody>
                {list && list.length > 0 && (
                    <tfoot>
                        <tr>
                            <td colSpan="2" className={`bg-dark text-light text-center font-bold`}>
                                합계
                            </td>
                            <td className={`bg-light text-center font-bold`} colSpan="2">
                                {quantityCnt}명
                            </td>
                            <td className={`bg-light text-center`}>
                            </td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizAppMap[a.key]) {
                                        const colspan = bizAppMap[a.key].fold ? 1 : 2 + bizAppMap[a.key].colAdd;
                                        if(bizAppMap[a.key].hasCellQuantity) {
                                            return (
                                                <>
                                                    <td className="bg-light font-bold">{bizAppMap[a.key].count}개</td>
                                                    <td className="bg-light font-bold">{bizAppMap[a.key].quantity}명</td>
                                                    <td className="bg-light font-bold" />
                                                </>
                                            );
                                        } else {
                                            return <td colSpan={colspan} className="bg-light font-bold">{bizAppMap[a.key].count}개</td>;
                                        }
                                    }
                                })
                            ) : <></>}
                        </tr>
                    </tfoot>
                )}
            </table>
        </div>
    );
};

const MasterInfo = ({ tableId, branches, bizApp, serviceAppList, appAuthTypeList, list, director, nurseryUniqId, nurseryUniqName, isRecontractSeason, changeList }) => {
    const [bizAppMap, setBizAppMap] = useState(false);
    const [appBranch, setAppBranch] = useState(false);
    const [showTransferModal, setShowTransferModal] = useState(false);
    const [transferInfo, setTransferInfo] = useState(false);
    const [transferStep, setTransferStep] = useState(1);
    const [isContractTransferring, setContractTransferring] = useState(false);

    useEffect(() => {
        initBizApp(bizApp, list);
        return () => {};
    }, [bizApp, serviceAppList, list]);
    const branchId = util.isRoleBranch() ? localStorage.getItem("login_branch_id") : 0;
    const initBizApp = (bizApp, list) => {
        if (bizApp && list) {
            const newBizAppMap = Table.func.getBizAppMap(bizApp, null, true);
            list.sort((a, b) => {
                return a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age;
            });
            updateContractTotal(newBizAppMap);
        }
    };
    const updateContractTotal = (bizAppMap) => {
        if (bizAppMap) {
            let newBizAppMap = { ...bizAppMap };
            let newAppBranch = {};
            Object.keys(bizAppMap).forEach((a) => {
                newBizAppMap[a].count = 0;
                newBizAppMap[a].quantity = 0;
                newAppBranch[a] = {};
            });
            
            list.forEach((c) => {
                if (c.is555) return;
                Object.keys(bizAppMap).forEach((a) => {
                    if (newBizAppMap[a].info && newBizAppMap[a].info.contractUseTas && c.app_auth[a] && c.app_auth[a].approval === "AP") {
                        newBizAppMap[a].count++;
                        newBizAppMap[a].quantity += Number(newBizAppMap[a].hasCellQuantity ? c[newBizAppMap[a].info.quantity.field[0]] : c.quantity);
                        if (!newAppBranch[a][c.app_auth[a].branch_id]) {
                            newAppBranch[a][c.app_auth[a].branch_id] = { id: c.app_auth[a].branch_id, name: c.app_auth[a].branch_name, quantity: 1 };
                        } else {
                            newAppBranch[a][c.app_auth[a].branch_id].quantity++;
                        }
                    }
                });
            });
            setBizAppMap(newBizAppMap);
            if (!appBranch) setAppBranch(newAppBranch);
        }
    };

    const onTransferContract = (app) => {
        const branchIds = Object.keys(appBranch[app]);
        if (branchIds && branchIds.length > 0) {
            let newTransferInfo = { app: {}, branchOrg: appBranch[app][branchIds[0]], branchDest: null, transferAll: false };
            newTransferInfo.app[app] = true;
            // 2024-10-30: 토모노트/한글수 이관 시 묶음 해제
            // if (app === "tomonote" || app === "momo") {
            //     if (appBranch["tomonote"][newTransferInfo.branchOrg.id]) newTransferInfo.app["tomonote"] = true;
            //     if (appBranch["momo"][newTransferInfo.branchOrg.id]) newTransferInfo.app["momo"] = true;
            // }
            newTransferInfo.transferAll = checkTransferContractAll(newTransferInfo);
            setTransferInfo(newTransferInfo);
            setShowTransferModal(true);
        }
    };

    const onChangeTransferBranch = (e) => {
        const selectedBranch = e.target.value;
        const newTransferInfo = { ...transferInfo };
        newTransferInfo.branchDest = branches.find((b) => b.id == selectedBranch);
        setTransferInfo(newTransferInfo);
    };
    const onChangeTransferApp = (e) => {
        const selectedApp = e.target.value;
        const newTransferInfo = { ...transferInfo };
        newTransferInfo.app[selectedApp] = e.target.checked;
        // 2024-10-30: 토모노트/한글수 이관 시 묶음 해제
        // if (selectedApp === "tomonote" || selectedApp === "momo") {
        //     if (appBranch["tomonote"][transferInfo.branchOrg.id]) transferInfo.app["tomonote"] = e.target.checked;
        //     if (appBranch["momo"][transferInfo.branchOrg.id]) transferInfo.app["momo"] = e.target.checked;
        // }
        newTransferInfo.transferAll = checkTransferContractAll(newTransferInfo);
        setTransferInfo(newTransferInfo);
    };

    const checkTransferContractAll = (transferInfo) => {
        let isCheckAll = true;
        Constant.CONTRACT_APP_LIST.forEach(a => {
            if(isCheckAll) {
                // 서비스가 이관 전 지사 서비스인 경우
                if(transferInfo.branchOrg.id in appBranch[a.id]) {
                    // 이관 체크되지 않은 경우 전체 이관이 아님
                    if(!transferInfo.app[a.id]) {
                        isCheckAll = false;
                    }
                }
            }
        });
        return isCheckAll;
    };

    const onTransferModalHide = () => {
        setTransferInfo(false);
        setContractTransferring(false);
        setShowTransferModal(false);
    };

    if(!serviceAppList || !bizAppMap) {
        return <></>;
    }

    let quantityCnt = 0;
    if (list) {
        list.forEach((c) => {
            // 555계정 계약 개수 제외
            if (c.is555) return;
            let quantityAdded = false;
            serviceAppList.forEach((a) => {
                if(a.contractUseTas && c.app_auth[a.key] && c.app_auth[a.key].approval === "AP") {
                    if(!quantityAdded && !bizAppMap[a.key].hasCellQuantity) {
                        quantityCnt += c[bizAppMap[a.key].info.quantity.field[0]];
                        quantityAdded = true;
                    }
                }
            });
        });
    }
    
    const colSpanApp = serviceAppList.reduce((acc, a) => bizAppMap[a.key] ? (acc + (bizAppMap[a.key].fold ? 1 : 2 + bizAppMap[a.key].colAdd)) : acc, 0);

    return (
        <>
            <table className="table table-bordered table-contract table-contract-view" id={tableId || "contractInfoTable"}>
                <Table.Header.Default bizApp={bizAppMap} serviceAppList={serviceAppList} appBranch={appBranch} isView={true} onTransferContract={onTransferContract} />
                <tbody>
                    {(!list || list.length === 0) && (
                        <tr className={"table-contract-tr"}>
                            <td colSpan={5 + colSpanApp}>계약이 존재하지 않습니다.</td>
                        </tr>
                    )}
                    {director &&
                        director.map((c, idx) => {
                            const appAuth = c.app_auth;
                            return (
                                <tr className={"table-contract-tr"} key={`table-contract-info-tr-${idx}`}>
                                    <td className="text-center table-contract-td">
                                        <Table.UserIdViewCell branchId={branchId} contract={c} serviceAppList={serviceAppList} />
                                    </td>
                                    <td style={{ textAlign: "left" }}>{c.name}</td>
                                    <td style={{ textAlign: "left", backgroundColor: "#f4f6f9" }}></td>
                                    <td style={{ textAlign: "left", backgroundColor: "#f4f6f9" }}></td>
                                    <td style={{ textAlign: "left", backgroundColor: "#f4f6f9" }}></td>

                                    {serviceAppList ? (
                                        serviceAppList.map((a) => {
                                            if(a.contractUseTas && bizAppMap[a.key]) {
                                                return (
                                                    <Table.ViewCell bizApp={bizAppMap[a.key]} age={c[a.age.field]} quantity={a.quantity.field[0]} auth={appAuth[a.key]} is555={true} role="D" needRecontract={false} />
                                                );
                                            }
                                        })
                                    ) : <></>}
                                </tr>
                            );
                        })}
                    {director && director.length > 0 && (
                        <tr className={"table-contract-tr"}>
                            <td
                                className="p-0 pb-1"
                                style={{ backgroundColor: "#eee" }}
                                colSpan={4 + colSpanApp}
                            ></td>
                        </tr>
                    )}
                    {list &&
                        list.map((c, idx) => {
                            const appAuth = c.app_auth;
                            const hasApproval = serviceAppList.reduce((acc, a) => acc || (c.app_auth[a.key] && (c.app_auth[a.key].approval == "WT" || c.app_auth[a.key].approval == "AP") == true), false);
                            const unionName = c.unionSelected ? c.unionSelected.name : '결합 없음';

                            return (
                                <tr className={"table-contract-tr"} key={`table-contract-list-master-info-${idx}`}>
                                    <td className="text-center table-contract-td">
                                        <Table.UserIdViewCell
                                            branchId={branchId}
                                            contract={c}
                                            serviceAppList={serviceAppList}
                                            onClassUpdate={(e) => {
                                                if (e.name) {
                                                    const newList = [...list];
                                                    newList[idx].class_name = e.name;
                                                    changeList(newList);
                                                }
                                            }}
                                        />
                                    </td>
                                    <td style={{ textAlign: "left", color: `${c.is_new && !c.is555 ? " red" : "#71748d"}` }}>{c.class_name}</td>
                                    <td style={{ textAlign: "left", color: `${c.is_new && !c.is555 ? " red" : "#71748d"}`, backgroundColor: "#f4f6f9" }}>{hasApproval ? c.quantity : ''}</td>
                                    <td style={{ color: `${c.is_new && !c.is555 ? " red" : "#71748d"}`, backgroundColor: "#f4f6f9" }}>{hasApproval ? (c.device == 'tablet' ? '태블릿' : '전자칠판') : ''}</td>
                                    <td className={`text-center ${c.unionSelected ? 'text-union' : 'text-gray'}`} style={{backgroundColor: "#f4f6f9"}}>{unionName}</td>

                                    {serviceAppList ? (
                                        serviceAppList.map((a) => {
                                            if(a.contractUseTas && bizAppMap[a.key]) {
                                                return (
                                                    <Table.ViewCell bizApp={bizAppMap[a.key]} age={c[a.age.field]} quantity={c[a.quantity.field[0]]} auth={appAuth[a.key]} is555={c.is555} isRecontractSeason={isRecontractSeason} />
                                                );
                                            }
                                        })
                                    ) : <></>}
                                </tr>
                            );
                        })}
                </tbody>
                {list && list.length > 0 && (
                    <tfoot>
                        <tr className={"table-contract-tr"}>
                            <td colSpan="2" className="bg-dark text-center text-light font-bold">
                                합계
                            </td>
                            <td className="bg-light text-center font-bold">
                                {quantityCnt}명
                            </td>
                            <td className="bg-light text-center font-bold">
                            </td>
                            <td className="bg-light text-center font-bold">
                            </td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizAppMap[a.key]) {
                                        const colspan = bizAppMap[a.key].fold ? 1 : 2 + bizAppMap[a.key].colAdd;
                                        if(bizAppMap[a.key].hasCellQuantity) {
                                            return (
                                                <>
                                                    <td className="bg-light font-bold">{bizAppMap[a.key].count}개</td>
                                                    <td className="bg-light font-bold">{bizAppMap[a.key].quantity}명</td>
                                                    <td className="bg-light font-bold" />
                                                </>
                                            );
                                        } else {
                                            return <td colSpan={colspan} className="bg-light font-bold">{bizAppMap[a.key].count}개</td>;
                                        }
                                    }
                                })
                            ) : <></>}
                        </tr>
                    </tfoot>
                )}
            </table>
            {showTransferModal && (
                <Modal size={"md"} show={showTransferModal} onHide={() => onTransferModalHide()} aria-labelledby="example-custom-modal-styling-title">
                    <LoadingOverlay active={isContractTransferring} spinner text="계약 이관 중...">
                        <Modal.Header className="bg-danger text-white" closeButton>
                            <Modal.Title id="example-custom-modal-styling-title">계약 지사 이관</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ overflow: "auto" }}>
                            <StepWizard initialStep={transferStep} isLazyMount={true}>
                                <TransferStep1
                                    branches={branches}
                                    transferInfo={transferInfo}
                                    appBranch={appBranch}
                                    serviceAppList={serviceAppList}
                                    onChangeTransferBranch={onChangeTransferBranch}
                                    onChangeTransferApp={onChangeTransferApp}
                                    onCancel={onTransferModalHide}
                                />
                                <TransferStep2
                                    branches={branches}
                                    nurseryUniqId={nurseryUniqId}
                                    nurseryUniqName={nurseryUniqName}
                                    transferInfo={transferInfo}
                                    appBranch={appBranch}
                                    serviceAppList={serviceAppList}
                                    onChangeTransferBranch={onChangeTransferBranch}
                                    onChangeTransferApp={onChangeTransferApp}
                                    onCancel={onTransferModalHide}
                                    onTransferContract={setContractTransferring}
                                />
                            </StepWizard>
                        </Modal.Body>
                    </LoadingOverlay>
                </Modal>
            )}
        </>
    );
};

const TransferStep1 = (props) => {
    useEffect(() => {}, [props.transferInfo]);
    const validateForm = () => {
        if (!props.transferInfo.branchDest) {
            toast.error("이관할 지사를 선택해 주세요.");
            return;
        }
        if (props.transferInfo.branchOrg.id === props.transferInfo.branchDest.id) {
            toast.error("동일한 지사로는 이관이 불가합니다.");
            return;
        }
        if (props.transferInfo.branchDest.status != "join") {
            if (!window.confirm("정말로 해지된 지사로 이관하시겠습니까?")) {
                return;
            }
        }
        let moveApp = 0;
        Object.keys(props.transferInfo.app).forEach((a) => {
            if (props.transferInfo.app[a]) {
                moveApp++;
            }
        });
        if (moveApp < 1) {
            toast.error("이관할 계약을 선택해 주세요.");
            return;
        }
        props.nextStep();
    };

    return (
        <>
            <div className="row">
                <div className="col">
                    <label htmlFor="edit_nursery">현재 지사</label>
                    <input className="form-control" type="text" value={props.transferInfo.branchOrg.name} disabled={true} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col">
                    <label htmlFor="edit_nursery">이관할 지사</label>
                    <select className="form-control mt-2" onChange={props.onChangeTransferBranch} value={props.transferInfo.branchDest ? props.transferInfo.branchDest.id : ""}>
                        <option value="">지사를 선택해 주세요.</option>
                        {props.branches &&
                            props.branches.map((branch) => {
                                return branch.status == "terminate" ? (
                                    <></>
                                ) : (
                                    <option value={branch.id} disabled={branch.id === props.transferInfo.branchOrg.id}>
                                        {branch.name}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col">
                    <label htmlFor="transferApp">이관할 계약</label>
                    <div>
                        {Constant.CONTRACT_APP_LIST.map((a) => {
                            return props.appBranch[a.id] && props.appBranch[a.id][props.transferInfo.branchOrg.id] ? (
                                <label className="custom-control custom-checkbox">
                                    <input
                                        type="checkbox"
                                        name="transferApp"
                                        value={a.id}
                                        checked={props.transferInfo.app[a.id]}
                                        className="custom-control-input"
                                        onChange={props.onChangeTransferApp}
                                        disabled={!(props.appBranch[a.id] && props.appBranch[a.id][props.transferInfo.branchOrg.id])}
                                    />
                                    <span className="custom-control-label">
                                        {a.name} - {props.appBranch[a.id][props.transferInfo.branchOrg.id].quantity}건
                                    </span>
                                </label>
                            ) : (
                                <></>
                            );
                        })}
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right">
                    <button
                        className="btn btn-muted mr-3"
                        onClick={() => {
                            props.onCancel();
                        }}
                        disabled={false}
                    >
                        취소
                        <i className="fas fa-times-circle ml-3" />
                    </button>
                    <button className="btn btn-success" onClick={validateForm} disabled={false}>
                        변경
                        <i className="fas fa-arrow-alt-circle-right ml-3" />
                    </button>
                </div>
            </div>
        </>
    );
};

const TransferStep2 = (props) => {
    useEffect(() => {}, [props.transferInfo.app, props.transferInfo.branchDest]);

    const submitTransferContract = () => {
        props.onTransferContract(true);
        axios({
            method: "post",
            url: `/api/contract/transfer`,
            data: {
                nurseryUniq: { id: props.nurseryUniqId, name: props.nurseryUniqName },
                transferBranchOrg: { id: props.transferInfo.branchOrg.id, name: props.transferInfo.branchOrg.name },
                transferBranchDest: { id: props.transferInfo.branchDest.id, name: props.transferInfo.branchDest.name },
                transferApp: props.transferInfo.app,
                transferAll: props.transferInfo.transferAll
            },
        })
            .then((res) => {
                if (res.status === 200 && res.data.code === 200) {
                    alert("계약 지사 이관이 완료 되었습니다.");
                    props.onTransferContract(false);
                    document.location.reload();
                } else {
                    toast.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                    props.onTransferContract(false);
                }
            })
            .catch((error) => {
                console.log(error);
                toast.error("알 수 없는 오류가 발생하였습니다. \n지속 발생시 관리자에게 문의해주세요.");
                props.onTransferContract(false);
            });
    };

    return (
        <>
            <div className="row">
                <div className="col">다음 내용을 확인 후 완료 버튼을 눌러주세요.</div>
            </div>
            <div className="row mt-3">
                <div className="col h5">
                    <ul>
                        <li>
                            <div style={{width: "120px", float: "left", backgroundColor: "#DDD"}}>원명</div>:&nbsp;{props.nurseryUniqName}
                        </li>
                        <li>
                            <div style={{width: "120px", float: "left", bacgroundColor: "#DDD"}}>현재 지사</div>:&nbsp;
                            <span className="text-primary">{props.transferInfo.branchOrg.name}</span>
                        </li>
                        <li>
                            <div style={{width: "120px", float: "left", backgroundColor: "#DDD"}}>이관할 지사</div>:&nbsp;
                            <span className="text-danger">
                                {props.transferInfo.branchDest.name}
                            </span>
                        </li>
                        <li>이관할 계약</li>
                        <ul className="list-group ml-3">
                            {Constant.CONTRACT_APP_LIST.map((a) => {
                                return props.transferInfo.app[a.id] ? (
                                    <li className="text-danger">
                                        {a.name} - {props.appBranch[a.id][props.transferInfo.branchOrg.id].quantity}건
                                    </li>
                                ) : (
                                    <></>
                                );
                            })}
                        </ul>
                    </ul>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-6">
                    <button
                        className="btn btn-primary"
                        onClick={() => {
                            props.previousStep();
                        }}
                    >
                        <i className="fas fa-arrow-alt-circle-left mr-3" />
                        이전 단계
                    </button>
                </div>
                <div className="col-6 text-right">
                    <button className="btn btn-danger mr-3" disabled={false} onClick={submitTransferContract}>
                        <i className="fas fa-paper-plane mr-2" />
                        완료
                    </button>
                    <button
                        className="btn btn-muted"
                        onClick={() => {
                            props.onCancel();
                        }}
                        disabled={false}
                    >
                        취소
                        <i className="fas fa-times-circle ml-3" />
                    </button>
                </div>
            </div>
        </>
    );
};

const RecontractInfo = ({ tableId, bizApp, serviceAppList, list, seasonInfo }) => {
    useEffect(() => {}, [bizApp, list]);

    const data = {};
    const ageSet = new Set();
    const recontractYearCheck = seasonInfo.recontractYear;

    if (list && list.length > 0) {
        list.forEach((c) => {
            const auth = c.app_auth;
            Object.keys(bizApp).forEach((a) => {
                if (auth[a] && auth[a].approval === "AP") {
                    let age = c.age;
                    if (a === "tomoenglish") {
                        age = c.english_age != null ? c.english_age : c.age;
                    } else {
                        age = c.age;
                    }
                    ageSet.add(Number(age));
                    if (
                        auth[a].recontract_year >= recontractYearCheck // 재계약 대상인지
                    ) {
                        // 재계약 체크가 되었는지
                        const cnt = data[`${age}_${a}_recontract`] || 0;
                        const cnt2 = data[`${a}_recontract`] || 0;
                        data[`${age}_${a}_recontract`] = cnt + 1;
                        data[`${a}_recontract`] = cnt2 + 1;
                    } else if (moment(auth[a].end_date).get("year") > recontractYearCheck) {
                        const cnt = data[`${age}_${a}_contract`] || 0;
                        const cnt2 = data[`${a}_contract`] || 0;
                        data[`${age}_${a}_contract`] = cnt + 1;
                        data[`${a}_contract`] = cnt2 + 1;
                    }
                }
            });
        });
    }

    return (
        <>
            <table className="table table-bordered table-contract table-contract-re-confirm" id={tableId || "contractInfoTable"}>
                <Table.Header.RecontractConfirm bizApp={bizApp} serviceAppList={serviceAppList} />
                <tbody>
                    {Array.from(ageSet)
                        .sort((a, b) => a - b)
                        .map((age, idx) => {
                            return (
                                <tr className="table-contract-tr" style={{ borderTop: `1px solid #e6e6f2` }} key={`table-contract-tr-re-confirm-${idx}`}>
                                    <td className="bg-primary-light text-center text-dark">{Table.func.ageStr(age)}</td>
                                    {serviceAppList ? (
                                        serviceAppList.map((a) => {
                                            if(a.contractUseTas && bizApp[a.key]) {
                                                return (
                                                    <>
                                                        <td className="bg-light text-center">{data[`${age}_${a.key}_contract`] || 0}</td>
                                                        <td className="text-center">{data[`${age}_${a.key}_recontract`] || 0}</td>
                                                    </>);
                                            } else {
                                                return <></>;
                                            }
                                        })
                                    ) : (
                                        <></>
                                    )}
                                </tr>
                            );
                        })}
                </tbody>
                {list && list.length > 0 && (
                    <tfoot>
                        <tr>
                            <td style={{ color: "#fff", backgroundColor: "#38419a" }}>소계</td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return (
                                            <>
                                                <td className="bg-primary-light text-center text-dark">{data[`${a.key}_contract`] || 0}개</td>
                                                <td className="bg-primary-light text-center text-dark">{data[`${a.key}_recontract`] || 0}개</td>
                                            </>);
                                    } else {
                                        return <></>;
                                    }
                                })
                            ) : (
                                <></>
                            )}
                        </tr>
                        <tr>
                            <td style={{ color: "#fff", backgroundColor: "#38419a" }}>총 계약 수량</td>
                            {serviceAppList ? (
                                serviceAppList.map((a) => {
                                    if(a.contractUseTas && bizApp[a.key]) {
                                        return (
                                            <td className="bg-primary-light text-center text-dark" colSpan="2">
                                                {(data[`${a.key}_contract`] || 0) + (data[`${a.key}_recontract`] || 0)}개
                                            </td>);
                                    } else {
                                        return <></>;
                                    }
                                })
                            ) : (
                                <></>
                            )}
                        </tr>
                    </tfoot>
                )}
            </table>
        </>
    );
};

export default {
    ContractViewBranch: ContractInfo,
    ContractViewMaster: MasterInfo,
    ContractViewRecontract: RecontractInfo,
};
